import { apiClient } from '@/services/api.service'

const ShippingService = {
  createShippingLabel: (identifier) => apiClient().post('/v1/admin/shipping_label/', { identifier })
}

export default ShippingService
